(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var main = document.querySelector('#infoarte main'); // import 'babel-polyfill';


var margin = {
  top: 40, right: 20, bottom: 40, left: 20
};
var width = parseInt(d3.select('.campo').style('width'), 10);
var height = parseInt(d3.select('.campo').style('height'), 10);
var innerWidth = width - margin.left - margin.right;
var innerHeight = height - margin.top - margin.bottom;

// ESCALAS
var espessura = d3.scaleLinear();
var espessuraMax = d3.scaleQuantize();
var pos_x = d3.scalePoint();
var pos_y = d3.scalePoint();
var tamanhoNode = d3.scaleQuantize();

var dados = [{}, {}];

var instanceSimulation = [];

// Cores das selecoes da esquerda e da direita (respectivamente) no ".range()"
var corLegenda = d3.scaleOrdinal().domain([0, 1]).range(['#FFD550', '#D38888']);

// Cria lista de nós a partir da base bruta
function extraiPos(base) {
  var j = [];
  base.forEach(function (d) {
    j.push({
      id: d.source,
      pos_x: +d.pos_x,
      pos_y: +d.pos_y
    });
  });

  return j;
}

// Para cada fluxo de passe, cria uma entrada de source -> target -> passes
function trataCSV(dadosCsv) {
  var csvHorizontal = [];
  dadosCsv.forEach(function (d) {
    Object.keys(d).forEach(function (item) {
      if (d[item] && item !== 'pos_x' && item !== 'pos_y' && d.source !== d[item]) {
        csvHorizontal.push({
          source: d.source,
          target: item,
          quant: +d[item]
        });
      }
    });
  });
  return csvHorizontal;
}

// O dado do fluxo de passes é direcional e inclui tanto o sentido A -> B quanto
// o sentido B -> A. O gráfico, porém, precisa simplificar tudo num só sentido.
// Essa função serve pra padronizar o sentido e a ordem dos dados
function organizaLinks(j) {
  var k = [];
  j.forEach(function (d) {
    var sourceTemp = d.source;
    var targetTemp = d.target;
    if (d.source > d.target) {
      k.push({
        source: targetTemp,
        target: sourceTemp,
        quant: d.quant
      });
    } else {
      k.push({
        source: d.source,
        target: d.target,
        quant: d.quant
      });
    }
  });

  k.sort(function (a, b) {
    if (a.source > b.source) return 1;
    if (a.source < b.source) return -1;
    if (a.target > b.target) return 1;
    if (a.target < b.target) return -1;
    // a must be equal to b
    return 0;
  });
  return k;
}

// Para que não existam linhas de passe duplicadas, vamos consolidar o valor do número
// de passes entre source/targets iguais (independente da ordem) numa única ocorrência
function somaLinks(data) {
  var linksTemp = [];
  var prevsource = '';
  var prevtarget = '';
  var sum = 0;
  data.forEach(function (d) {
    sum = d.quant;
    if (d.source === prevsource && d.target === prevtarget) {
      linksTemp[linksTemp.length - 1].quant += sum;
    } else {
      linksTemp.push({
        source: d.source,
        target: d.target,
        quant: d.quant
      });
    }
    prevsource = d.source;
    prevtarget = d.target;
  });
  return linksTemp;
}

function start(param, index) {
  // Parâmetros das forças da simulação da física
  var simulation = d3.forceSimulation().force('link', d3.forceLink().id(function (d) {
    return d.id;
  })).force('center', d3.forceCenter(width / 2, height / 2));
  var campinho = d3.select('svg#campo' + index).append('g');
  campinho.attr('fill', '#fff');
  instanceSimulation.push(simulation);

  // setinha do SENTIDO DE ATAQUE
  var ataque = d3.select('svg#campo' + index).append('g').attr('class', 'labelSentido').attr('transform', 'translate(' + (width - 20) + ',' + (margin.top + 80) + ')rotate(-90)');

  ataque.append('text').html('Sentido do ataque &#x27a4;');

  espessuraMax.domain([300, 700]).range([12, 20, 26]);
  // espessura.domain(d3.extent(param.links, d => d.quant)).range([1, espessuraMax(width)]);
  espessura.domain([1, 50]).range([1, espessuraMax(width)]);
  // Domain manualmente modificado pro jogo contra a Costa Rica
  tamanhoNode.domain([300, 700]).range([6, 10, 13]);

  pos_x.domain(d3.range(9)).range([innerWidth + margin.left, margin.left]).padding([0.5]);
  pos_y.domain(d3.range(11)).range([innerHeight, margin.top]);

  // LINKS
  var linkG = campinho.append('g').attr('class', 'links_g');
  var link = linkG.selectAll('.links').data(param.links).enter().append('line').attr('class', 'links').attr('stroke', corLegenda(index)).attr('stroke-opacity', 1);

  link.attr('stroke-width', function (d) {
    return espessura(d.quant);
  });

  // LABELS DA QUANTIDADE DOS PASSES
  var labelPasses = linkG.selectAll('.label-quant').data(param.links).enter().append('text').attr('class', 'label-quant').attr('text-anchor', 'middle').attr('fill', 'black').attr('display', 'none').attr('pointer-events', 'none').text(function (d) {
    return d.quant;
  });

  // NODES
  var nodes = campinho.selectAll('.nodes').data(param.nodes).enter().append('g').attr('class', 'nodes').attr('opacity', 1).style('cursor', 'pointer');

  nodes.append('circle').attr('class', 'node_circle').attr('r', tamanhoNode(main.clientWidth)).attr('fill', 'black');

  nodes.on('mouseover', highlightON).on('mouseout', highlightOFF);

  // LABELS
  nodes.append('text').attr('class', 'labels').attr('text-anchor', 'middle').attr('fill', 'black').attr('y', '1.75em').text(function (d) {
    return d.id;
  });

  // HIGHLIGHTS
  var timing = 100;

  function highlightON(item) {
    link.transition().duration(timing).attr('stroke-opacity', function (o) {
      return o.source.id === item.id || o.target.id === item.id ? 1 : 0.15;
    });

    var linkedByIndex = {};
    link.each(function (d) {
      linkedByIndex[d.source.index + ', ' + d.target.index] = 1;
      linkedByIndex[d.source.index + ', ' + d.source.index] = 1;
      linkedByIndex[d.target.index + ', ' + d.source.index] = 1;
      linkedByIndex[d.target.index + ', ' + d.target.index] = 1;
    });

    function neighboring(a, b) {
      return linkedByIndex[a.index + ', ' + b.index] || linkedByIndex[b.index + ', ' + a.index];
    }
    nodes.transition().duration(timing).attr('opacity', function (o) {
      return neighboring(item, o) ? 1 : 0.05;
    });

    labelPasses.transition().duration(timing).attr('display', function (o) {
      return o.source.id === item.id || o.target.id === item.id ? 'block' : 'none';
    });
  }

  function highlightOFF() {
    link.transition().duration(timing).attr('stroke-opacity', 1);
    nodes.transition().duration(timing).attr('opacity', 1);
    labelPasses.transition().duration(timing).attr('display', 'none');
  }

  // INICIA SIMULAÇÃO
  simulation.nodes(param.nodes).on('tick', ticked);

  simulation.force('link').links(param.links).distance(100);

  function ticked() {
    link.attr('x1', function (d) {
      return d.source.x;
    }).attr('y1', function (d) {
      return d.source.y;
    }).attr('x2', function (d) {
      return d.target.x;
    }).attr('y2', function (d) {
      return d.target.y;
    });

    nodes.attr('transform', function (d) {
      d.fx = pos_x(d.pos_x);
      d.fy = pos_y(d.pos_y);
      return 'translate(' + d.fx + ',' + d.fy + ')';
    });

    labelPasses.attr('x', function (d) {
      return (d.source.x + d.target.x) / 2;
    }).attr('y', function (d) {
      return (d.source.y + d.target.y) / 2;
    });
  }

  // LEGENDA
  var legenda = d3.select('#legenda' + index).append('svg');

  legenda.append('g').attr('class', 'legendSize').attr('transform', 'translate(20, 20)');

  var legendSizeLine = d3.legendSize().scale(espessura).shape('line').orient('horizontal').labelWrap(100).shapeWidth(40).labelOffset(20).labelFormat(d3.format('.0f')).title('Volume de passes');

  legenda.select('.legendSize').call(legendSizeLine);
  d3.selectAll('#legenda' + index + ' .swatch').attr('stroke', corLegenda(index));
}

function updateLink() {
  espessura.domain([1, 50]).range([1, espessuraMax(main.clientWidth)]);
  var allLinks = document.querySelectorAll('.links_g');
  allLinks.forEach(function (item) {
    d3.select(item).selectAll('.links').attr('stroke-width', function (d) {
      return espessura(d.quant);
    });
  });
}

function resize() {
  var campo = document.querySelector('.bg-campinho');
  if (campo.clientWidth < 280) return;
  width = campo.clientWidth > 600 ? 600 : campo.clientWidth;

  height = width * 1.5;

  innerWidth = width - margin.left - margin.right;
  innerHeight = height - margin.top - margin.bottom;

  pos_x.range([innerWidth + margin.left, margin.left]);
  pos_y.range([innerHeight, margin.top]);

  d3.selectAll('.campo').attr('width', width).attr('height', height);

  d3.selectAll('.labelSentido').attr('transform', 'translate(' + (width - 20) + ',' + (margin.top + 80) + ')rotate(-90)');

  d3.selectAll('.nodes').attr('transform', function (d) {
    d.fx = pos_x(d.pos_x);
    d.fy = pos_y(d.pos_y);
    return 'translate(' + d.fx + ',' + d.fy + ')';
  });

  d3.selectAll('.node_circle').attr('r', tamanhoNode(main.clientWidth));

  instanceSimulation.forEach(function (instance) {
    instance.force('link', d3.forceLink().id(function (d) {
      return d.id;
    }));
    instance.force('center', d3.forceCenter(width / 2, height / 2));
    instance.alpha(1).restart();
  });
  updateLink();
}

function transformaDados(arr, index) {
  dados[index].nodes = extraiPos(arr);
  var response = organizaLinks(trataCSV(arr));
  dados[index].links = somaLinks(response);
  start(dados[index], index);
  d3.select(window).on('resize', resize);
}

function recebeDados(d) {
  var index = 0;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      transformaDados(item, index);
      index += 1;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

Promise.all([d3.csv((0, _util2.default)(0) + '/csv/jogo3-brasil.csv'), d3.csv((0, _util2.default)(0) + '/csv/jogo3-adv.csv')]).then(recebeDados);

resize();

},{"./util":2}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setBucketURL;

var _config = require('../../../config');

function setBucketURL(index) {
  var bucket = {
    dev: ['infograficos-estaticos-dev'],
    prod: ['https://deoliyp60f2gq.cloudfront.net']
  };

  var host = window.location.host.split('.')[0];
  if (host === 'infograficos' || host === 'oglobo' || host === 'm' || host === 'blogs') {
    return bucket.prod[index] + '/copa-passes/' + _config.FOLDERS3;
  }
  // return `https://${bucket.dev[index]}.s3.amazonaws.com/copa-passes/${FOLDERS3}`;
  return bucket.prod[index] + '/copa-passes/' + _config.FOLDERS3;
}

},{"../../../config":3}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLDERS3 = exports.Paths = exports.Defaults = undefined;

var _package = require('./package.json');

var FOLDERS3 = 'brasil_servia';

var Defaults = {
  s3URL: 'https://deoliyp60f2gq.cloudfront.net/' + _package.name + '/' + FOLDERS3 + '/',
  qaURL: 'https://infograficos-estaticos-dev.s3.amazonaws.com/' + _package.name + '/' + FOLDERS3 + '/'
};

var Paths = {
  images: 'app/assets/img/**/*.{jpg,png,gif,svg}',
  styles: 'app/assets/sass/**/*.scss',
  scripts: ['app/assets/js/**/*.js', '!node_modules/**'],
  views: 'app/views/**/*.pug'
};

exports.Defaults = Defaults;
exports.Paths = Paths;
exports.FOLDERS3 = FOLDERS3;

},{"./package.json":4}],4:[function(require,module,exports){
module.exports={
  "name": "copa-passes",
  "version": "1.0.0",
  "description": "",
  "main": "",
  "scripts": {
    "start": "gulp",
    "build": "NODE_ENV=PROD gulp build",
    "build:qa": "NODE_ENV=QLT gulp build",
    "eslint": "eslint app/assets/js --no-cache"
  },
  "author": "O Globo",
  "license": "ISC",
  "devDependencies": {
    "babel-cli": "^6.26.0",
    "babel-core": "^6.26.0",
    "babel-preset-env": "^1.6.0",
    "babel-register": "^6.26.0",
    "babelify": "^7.3.0",
    "browser-sync": "^2.9.11",
    "browserify": "^14.4.0",
    "del": "^3.0.0",
    "eslint": "^4.18.1",
    "eslint-config-airbnb-base": "^12.1.0",
    "eslint-plugin-import": "^2.9.0",
    "gulp": "^3.9.1",
    "gulp-cache": "^1.0.1",
    "gulp-concat": "^2.6.1",
    "gulp-cssnano": "^2.1.2",
    "gulp-imagemin": "^2.2.1",
    "gulp-load-plugins": "^1.5.0",
    "gulp-plumber": "^1.1.0",
    "gulp-pug": "^3.3.0",
    "gulp-sass": "^3.1.0",
    "gulp-sass-variables": "^1.1.1",
    "gulp-sourcemaps": "^2.6.0",
    "gulp-uglify": "^1.3.0",
    "gulp-watch": "^4.3.3",
    "pug": "^2.0.0-beta11",
    "pug-lint": "^2.5.0",
    "run-sequence": "^2.0.0",
    "sass-lint": "^1.12.1",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0"
  },
  "dependencies": {
    "babel-polyfill": "^6.26.0"
  }
}

},{}]},{},[1])

